import type {ReactNode, Ref} from 'react'
import {clsx} from 'clsx'
import styles from './CommentLayout.module.css'

interface CommentLayoutProps {
  header: ReactNode
  children: ReactNode
  id?: string
  ref?: Ref<HTMLDivElement>
  className?: string
  tabIndex?: number
}

export function CommentLayout({header, children, className, ...props}: CommentLayoutProps) {
  return (
    <div className={clsx(styles.container, className)} {...props}>
      <div className={styles.header}>{header}</div>
      <div className={styles.body}>{children}</div>
    </div>
  )
}
